var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[[_c('v-toolbar-title',[_vm._v("Approvals")]),_c('v-spacer')]],2),_c('v-divider',{staticClass:"my-0 mx-6"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }